import { Dispatch, PropsWithChildren, SetStateAction, useEffect, useMemo, useState } from 'react';
import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface AdminLayoutContextProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
}

const AdminLayoutContext = createContext<AdminLayoutContextProps>(undefined!);

export const AdminLayoutProvider = ({ children }: PropsWithChildren) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    setIsDrawerOpen(false);
  }, [location]);

  const values = useMemo(
    () => ({
      isDrawerOpen,
      setIsDrawerOpen,
    }),
    [isDrawerOpen]
  );
  return <AdminLayoutContext.Provider value={values}>{children}</AdminLayoutContext.Provider>;
};

export function useAdminLayoutContext(): AdminLayoutContextProps {
  const context = useContext(AdminLayoutContext);

  if (typeof context === 'undefined') {
    throw new Error('useAdminLayoutContext should be used within the AdminLayoutContext provider!');
  }

  return context;
}
